import logo from './logo.svg';
import './App.css';
import Navbar from './Component/Navbar/NavBar';
import Hero from './Component/Hero/Hero';
import AboutSection from './Component/About/AboutSection';
import ProjectSection from './Component/Project/ProjectSection';
import ContactSection from './Component/Contact/ContactSection';
import FooterSection from './Component/Footer/FooterSection';

function App() {
  return (
    <>
     <Navbar/>
     <Hero/>
     <AboutSection/>
     <ProjectSection/>
     <ContactSection/>
     <FooterSection/>
    </>
  );
}

export default App;
